import { render, staticRenderFns } from "./Compra.vue?vue&type=template&id=f071c048&scoped=true&"
import script from "./Compra.vue?vue&type=script&lang=js&"
export * from "./Compra.vue?vue&type=script&lang=js&"
import style0 from "./Compra.vue?vue&type=style&index=0&id=f071c048&lang=scss&scoped=true&"
import style1 from "./Compra.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Compra.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f071c048",
  null
  
)

export default component.exports